function ArrowLongRightIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66683 17.3334H21.5602L15.0535 23.84C14.5335 24.36 14.5335 25.2134 15.0535 25.7334C15.5735 26.2534 16.4135 26.2534 16.9335 25.7334L25.7202 16.9467C26.2402 16.4267 26.2402 15.5867 25.7202 15.0667L16.9468 6.26671C16.4268 5.74671 15.5868 5.74671 15.0668 6.26671C14.5468 6.78671 14.5468 7.62671 15.0668 8.14671L21.5602 14.6667H6.66683C5.9335 14.6667 5.3335 15.2667 5.3335 16C5.3335 16.7334 5.9335 17.3334 6.66683 17.3334Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ArrowLongRightIcon;
